import React, { useEffect } from "react";
import { useState, useCallback } from "react";
import logo from "../../../../img/LOGO.webp";
const SubcatItem = ({ subCat, subCatObj }) => {
  const [isActive, setIsActive] = useState(false);
  // console.log(subCatObj);
  const scroll = useCallback(() => {
    const views = [];
    subCat.forEach((element) => {
      const inView = document
        .getElementById(element)
        ?.getBoundingClientRect()?.top;

      if (inView >= 0) {
        views.push({ VIEW: inView, ELEMENT: element });
      }
    });

    if (views.length > 0) {
      const closest = views.reduce((first, second) => {
        if (second.VIEW < 0) {
          return first;
        }
        return first.VIEW < second.VIEW ? first : second;
      }).ELEMENT;
      const index = subCat.findIndex((cat) => {
        if (cat === closest) {
          return true;
        }
      });

      const elemet = document.getElementById(`${closest}sideBar`);
      const rect = elemet?.getBoundingClientRect();
      const isVisible =
        rect?.top >= 0 &&
        rect?.left >= 0 &&
        rect?.bottom <=
          (window.innerHeight ||
            document.documentElement
              .clientHeight) /* or $(window).height() */ &&
        rect?.right <=
          (window.innerWidth ||
            document.documentElement.clientWidth); /* or $(window).width() */
      if (!isVisible) {
        elemet?.scrollIntoView({
          inline: "center",
          behavior: "auto",
        });
      }
      setIsActive(index);
    }
  }, [subCat, isActive]);

  useEffect(() => {
    document.addEventListener("scroll", scroll);

    return () => {
      document.removeEventListener("scroll", scroll);
    };
  }, [subCat]);

  const subCategorySelected = useCallback((index, subCatID) => {
    setIsActive(index);
    window.scrollTo({
      behavior: "smooth",
      top:
        document.getElementById(subCatID).getBoundingClientRect()?.top -
        document.body.getBoundingClientRect().top -
        10,
    });
  }, []);

  return subCatObj?.map((subCat, index) => {
    const { subCatName, subCatImgURL } = subCat;
    return (
      <div
        key={subCatName}
        className={`subcat-item ${index === isActive ? "active" : " "}`}
        onClick={() => subCategorySelected(index, subCatName)}
        id={`${subCatName}sideBar`}
      >
        <div className="subcat-img">
          <img
            src={`${subCatImgURL ? subCatImgURL : logo}`}
            loading="lazy"
            alt="product"
            width="auto"
            height="100%"
          />
        </div>
        <h4>{subCatName}</h4>
      </div>
    );
  });
};

export default SubcatItem;
